import { z } from 'zod';

// Mirrors the server checks (private.validate_customer / normalize_phone) so
// errors appear next to the field before submit. The server stays the judge.
export const contactSchema = z.object({
  name: z
    .string()
    .transform((s) => s.trim().replace(/\s+/g, ' '))
    .pipe(z.string().min(2, 'Укажите имя').max(60, 'Не длиннее 60 символов')),
  phone: z.string().refine((p) => {
    const d = p.replace(/\D/g, '');
    return d.length >= 10 && d.length <= 15;
  }, 'Проверьте номер телефона'),
  car: z
    .string()
    .transform((s) => s.trim().replace(/\s+/g, ' '))
    .pipe(z.string().min(2, 'Укажите марку и модель').max(80, 'Не длиннее 80 символов')),
  comment: z.string().max(500, 'Не длиннее 500 символов'),
});

export type ContactForm = z.input<typeof contactSchema>;
export type ContactErrors = Partial<Record<keyof ContactForm, string>>;

export function validateContact(form: ContactForm): { ok: true; value: z.output<typeof contactSchema> } | { ok: false; errors: ContactErrors } {
  const r = contactSchema.safeParse(form);
  if (r.success) return { ok: true, value: r.data };
  const errors: ContactErrors = {};
  for (const i of r.error.issues) {
    const k = i.path[0] as keyof ContactForm;
    errors[k] ??= i.message;
  }
  return { ok: false, errors };
}

/** Light formatting while typing: "+7 916 123-45-67". */
export function formatPhoneInput(raw: string) {
  let d = raw.replace(/\D/g, '');
  if (!d) return raw.startsWith('+') ? '+' : '';
  if (d.startsWith('8') && d.length <= 11) d = '7' + d.slice(1);
  if (!d.startsWith('7')) return '+' + d.slice(0, 15);
  const p = d.slice(1);
  let out = '+7';
  if (p.length) out += ' ' + p.slice(0, 3);
  if (p.length > 3) out += ' ' + p.slice(3, 6);
  if (p.length > 6) out += '-' + p.slice(6, 8);
  if (p.length > 8) out += '-' + p.slice(8, 10);
  return out;
}
